import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}failedimportorders/search`;

export interface SearchFailedOrdersQueryArgs {
  searchQuery: string;
}

export interface FailedOrderDto {
  id: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const searchFailedOrdersRequest = (
  payload: SearchFailedOrdersQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { term: payload.searchQuery }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const searchFailedOrdersQuery = async (
  payload: SearchFailedOrdersQueryArgs,
): Promise<BackResponse<FailedOrderDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FailedOrderDto[]>>(
      searchFailedOrdersRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
